import { gql } from '@apollo/client';
import { CORE_TOOL_ORDER_CATALOG_FIELDS } from './tool-order-catalog';

export const CREATE_TOOL_ORDER_INVENTORY = gql`
  mutation CreateToolOrderInventory($toolOrderInventoryInput: ToolOrderInventoryInput!) {
    createToolOrderInventory(toolOrderInventoryInput: $toolOrderInventoryInput) {
      data {
        id
        toolInventoryId
        toolOrderCatalogId
        dispatchQuantity
        dispatchedBy
      }
      error
    }
  }
`;

export const PICK_TOOL_ORDER_INVENTORY = gql`
  ${CORE_TOOL_ORDER_CATALOG_FIELDS}
  mutation PickInventory($pickToolOrderInventoryInput: PickToolOrderInventoryInput!) {
    pickInventory(pickToolOrderInventoryInput: $pickToolOrderInventoryInput) {
      toolOrderCatalog {
        ...CoreToolOrderCatalogFields
        toolOrderInventories {
          id
          # checkedInBy checkedIn properties are no longer part of the tool order inventory type as the checkIn functionality has changed this
          # checkedInQuantity
          # checkedInToolRoomId
          dispatchQuantity
          toolInventoryId
          toolOrderCatalogId
        }
      }
      toolOrderInventory {
        id
        dispatchQuantity
        # checkedInQuantity checkedIn fields are no longer part of the tool order inventory as checkIns can happen without a related tool order inventory
        # checkedInBy
        # checkedInToolRoomId
        createdDate
        createdBy
        updatedDate
        updatedBy
        toolOrderCatalogId
        toolInventoryId
      }
    }
  }
`;

export const UPDATE_TOOL_ORDER_INVENTORY = gql`
  mutation UpdateToolOrderInventory($updateToolOrderInventoryInput: UpdateToolOrderInventoryInput!) {
    updateToolOrderInventory(updateToolOrderInventoryInput: $updateToolOrderInventoryInput) {
      errors
      toolOrderInventory {
        id
        dispatchQuantity
        dispatcherComments
        dispatcherCommentsBy
        createdDate
        createdBy
        updatedDate
        updatedBy
        toolOrderCatalogId
        toolInventoryId
        status
        toolInventory {
          id
          barCode
        }
        toolOrderCatalog {
          id
          alreadyIssuedCount
        }
      }
    }
  }
`;
export const DELETE_TOOL_ORDER_INVENTORY = gql`
  mutation DeleteToolOrderInventory($deleteToolOrderInventoryInput: DeleteToolOrderInventoryInput!) {
    deleteToolOrderInventory(deleteToolOrderInventoryInput: $deleteToolOrderInventoryInput) {
      toolOrder {
        id
        toolOrderCatalogs {
          id
          toolOrderInventories {
            id
          }
        }
      }
      id
      errors
    }
  }
`;
export const SEARCH_GROUPED_PARENT_INVENTORY = gql`
  query SearchGroupedParentInventories($searchInput: SearchInput) {
    searchGroupedParentInventories(searchInput: $searchInput) {
      items {
        id
        barCodeId
        toolCatalog {
          id
          toolCatalogImageUrl
          inventoryType
          uom {
            id
            abbreviation
          }
          toolCategory {
            id
            name
          }
        }
        toolCatalogId
        limitCount
        isSerialized
        isLocked
        description
        totalCount
        onHandCount
        updatedBy
        updatedDate
        createdBy
        updatedByUser {
          id
          firstName
          lastName
        }
        createdByUser {
          id
          firstName
          lastName
        }
      }
    }
  }
`;
export const SEARCH_GROUPED_PARENT_INVENTORY_COUNT = gql`
  query Query($searchInput: SearchInput) {
    groupedParentInventoryCount(searchInput: $searchInput)
  }
`;
